/**
 * PremiumBadge Component
 * Displays a diamond badge for premium users
 * Frontend-only, no business logic
 */

const PremiumBadge = ({ size = 14, className = "" }) => {
  return (
    <svg 
      xmlns="http://www.w3.org/2000/svg" 
      width={size} 
      height={size} 
      viewBox="0 0 24 24" 
      fill="#7FD4FF"
      className={className}
      style={{ display: 'inline-block', verticalAlign: 'middle' }}
      aria-label="Premium"
      title="Premium Member"
    >
      <path d="M12 3l7 6-7 12-7-12 7-6z"/>
    </svg>
  );
};

export default PremiumBadge;
